import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { StatusPageLayout } from '../components/layout/StatusPageLayout';
import { ApiService } from '../services/apiService';
// @mcc-dev-preview:import
import { parseDevState } from '../dev/devPreview';
// @mcc-dev-preview:import
import { DEV_PREVIEW_BANXA_STATUS_URL } from '../dev/devPreviewMocks';

// @mcc-dev-preview:start final-step-dev-state
const FINAL_STEP_DEV_STATES = ['loading', 'with-banxa-link'] as const;
// @mcc-dev-preview:end final-step-dev-state

const FinalStep: React.FC = () => {
  const [searchParams] = useSearchParams();
  const cardId = searchParams.get('cardId');
  const [banxaStatusUrl, setBanxaStatusUrl] = useState<string | null>(null);
  const [loadingBanxaUrl, setLoadingBanxaUrl] = useState(true);
  // @mcc-dev-preview:start final-step-dev-state
  const devState = parseDevState(searchParams, FINAL_STEP_DEV_STATES);
  // @mcc-dev-preview:end final-step-dev-state

  // @mcc-dev-preview:start final-step-dev-state
  useEffect(() => {
    if (!devState) return;

    if (devState === 'loading') {
      setBanxaStatusUrl(null);
      setLoadingBanxaUrl(true);
      return;
    }

    setBanxaStatusUrl(DEV_PREVIEW_BANXA_STATUS_URL);
    setLoadingBanxaUrl(false);
  }, [devState]);
  // @mcc-dev-preview:end final-step-dev-state

  useEffect(() => {
    // @mcc-dev-preview:start final-step-dev-state
    if (devState) return;
    // @mcc-dev-preview:end final-step-dev-state

    if (!cardId) {
      setLoadingBanxaUrl(false);
      return;
    }
    let cancelled = false;
    ApiService.getBanxaOrderStatusUrl(cardId)
      .then((res) => {
        if (!cancelled && res.success && res.data?.banxaStatusUrl) {
          setBanxaStatusUrl(res.data.banxaStatusUrl);
        }
      })
      .catch(() => {
        if (!cancelled) setBanxaStatusUrl(null);
      })
      .finally(() => {
        if (!cancelled) setLoadingBanxaUrl(false);
      });
    return () => { cancelled = true; };
  }, [cardId, devState]);

  return (
    <StatusPageLayout
      variant="loading"
      title="Final step"
      body="We're in the final step of activation. This usually takes a few minutes. If there are any unforeseen issues, we'll reach out to you via email."
    >
      {!loadingBanxaUrl && banxaStatusUrl && (
        <a
          className="ev-link-on-card"
          href={banxaStatusUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          Check order status with Banxa
        </a>
      )}
    </StatusPageLayout>
  );
};

export default FinalStep;
